<twc-trowser (close)="onClosePopupProject()"
    [caption]="titlePopupProject | translate" class="dialog-project">
    <twc-trowser-content>
        <cw-create-project-content *ngIf="couldShowCreateComponent" [type]="projectType"
            [shouldSkipAclCheck]="popupOptions?.data?.shouldSkipAclCheck ?? false"
            [shouldSkipLayers]="popupOptions?.data?.shouldSkipLayers ?? true" [jobSite]="popupOptions?.data?.jobSite"
            [shouldOpenProjectViewer]="popupOptions?.data?.shouldOpenProjectViewer ?? true">
        </cw-create-project-content>
    </twc-trowser-content>
</twc-trowser>